import React from 'react';
import CustomTooltip from '../../../../components/CustomTooltip';
import { twMerge } from 'tailwind-merge';

interface IRow {
  text?: string | React.ReactNode;
  tooltipId?: string;
  icon: React.ReactNode;
  showTooltip?: boolean;
  testId?: string;
}

const IconRow: React.FC<IRow> = ({
  icon,
  text,
  tooltipId,
  showTooltip,
  testId,
}) => {
  return (
    <div className="flex items-center gap-1.5">
      {icon}
      <span
        data-tooltip-id={tooltipId}
        className={twMerge(
          'text-sm desktop:text-base font-medium text-neutral-800 truncate',
          tooltipId && 'cursor-pointer',
        )}
        data-testid={testId}
      >
        {text}
      </span>
      {showTooltip && (
        <CustomTooltip
          id={tooltipId}
          place="bottom"
          content={text as string}
          className="max-w-xs break-all"
        />
      )}
    </div>
  );
};

export default IconRow;
